// extracted by mini-css-extract-plugin
module.exports = {"page":"Geo_History_3_7_page__2RLn2","question_body":"Geo_History_3_7_question_body__3xtrv","answers":"Geo_History_3_7_answers__27Mrp"};